namespace GeniuzPOS.Product {
    export class CsColorColumns {
        static columnsKey = 'Product.CsColor';
    }
}
